<template>
    <svg
        height="24px"
        width="24px"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
    >
        <path
            d="M5 19a4 4 0 100-8 4 4 0 000 8zM8.5 7.5h6M19 15l-4-7.5h-.5m0 0l2-3m0 0H14m2.5 0h2"
            stroke-width="0.99"
            stroke-linecap="round"
            stroke-linejoin="round"
        ></path>
        <path
            d="M5 15l3.5-7.5L12 14h3M8.5 7.5c-.333-1-1.5-3-3.5-3"
            stroke="currentColor"
            stroke-width="0.99"
            stroke-linecap="round"
            stroke-linejoin="round"
        ></path>
        <path
            d="M19 19a4 4 0 100-8 4 4 0 000 8z"
            stroke="currentColor"
            stroke-width="0.99"
            stroke-linecap="round"
            stroke-linejoin="round"
        ></path>
    </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
    name: "oss-bicycle",
});
</script>
